import { render, staticRenderFns } from "./CreateMovie.vue?vue&type=template&id=dbc09540&scoped=true"
import script from "./CreateMovie.vue?vue&type=script&lang=js"
export * from "./CreateMovie.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=dbc09540&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc09540",
  null
  
)

export default component.exports